import {
  ChangeEvent,
  createRef,
  MouseEvent,
  SyntheticEvent,
  useEffect,
  useRef,
  useState,
} from "react";
import { useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import useMeasure from "react-use-measure";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import useQuery from "../../hooks/useQuery";

import {
  selectBrands,
  // selectBrandCollection,
} from "../../redux/shop/shop.selectors";

import useStyles from "./shop-by-brand-menu.styles";

import SearchIcon from "../../assets/icons/search-icon";
import CloseIcon from "../../assets/icons/close-icon";

interface EachBrandType {
  name: string;
  id: string;
}

interface BrandType {
  group: string;
  brands: EachBrandType[];
}

const GroupBtn = (props: any) => {
  const matches = useMediaQuery("(min-width:1200px)");

  const { element, selectedGroup, handleGroupClick } = props;
  const [selected, setSelected] = useState<boolean | undefined>(undefined);
  const classes = useStyles({ selectedForBtn: selected, matches });

  useEffect(() => {
    if (selectedGroup === "") {
      setSelected(undefined);
    } else {
      setSelected(element.group === selectedGroup);
    }
  }, [selectedGroup]);

  return (
    <button
      key={element.group}
      value={element.group}
      onClick={handleGroupClick}
      className={classes.groupBtn}
    >
      {element.group}
    </button>
  );
};

const Brand = ({
  element,
  selectedGroup,
  setOpen,
  closeAll,
}: {
  element: BrandType;
  selectedGroup: string;
  setOpen: any;
  closeAll?: any;
}) => {
  const matches = useMediaQuery("(min-width:1200px)");

  const [selected, setSelected] = useState<boolean | undefined>(undefined);
  const classes = useStyles({ selected, matches });

  useEffect(() => {
    if (selectedGroup === "") {
      setSelected(undefined);
    } else {
      setSelected(element.group === selectedGroup);
    }
  }, [selectedGroup]);

  return (
    <div key={element.group} className={classes.brand}>
      <div className={classes.brandGroup}>{element.group}</div>
      <div className={classes.brandTitles}>
        {element.brands.map((brand) => (
          <Link
            key={brand.id}
            to={`/shop?brandId=${brand.id}`}
            onClick={() => {
              if (closeAll) {
                closeAll();
              }
              if (setOpen) {
                setOpen(false);
              }
            }}
          >
            {brand.name}
          </Link>
        ))}
      </div>
    </div>
  );
};

const ShopByBrandMenu = ({
  open = true,
  setOpen,
  closeDrawer,
  closeAll,
}: {
  open?: boolean;
  setOpen?: any;
  closeDrawer?: any;
  closeAll?: any;
}) => {
  const query = useQuery();
  const location = useLocation();
  const history = useHistory();
  const [ref, bounds] = useMeasure();
  const brands = useSelector(selectBrands);

  const matches = useMediaQuery("(min-width:1200px)");

  const [searchString, setSearchString] = useState("");

  const classifiedBrands = brands.reduce((acc: BrandType[], current: any) => {
    const group = current.brandName[0];
    if (acc.every((element: any) => element.group !== group)) {
      acc.push({
        group,
        brands: [{ name: current.brandName, id: current.dashboardCollection }],
      });
    } else {
      acc
        .find((element: any) => element.group === group)
        ?.brands.push({
          name: current.brandName,
          id: current.dashboardCollection,
        });
    }
    return acc;
  }, []);

  const [selectedGroup, setSelectedGroup] = useState("");

  const classes = useStyles({
    selectedGroup,
    open,
    brandsHeight: bounds.height,
    matches,
  });

  useEffect(() => {
    setSelectedGroup("");
  }, [location]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const value = e.currentTarget.value;
    setSearchString(value);
  };

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault();
    if (searchString) {
      setSearchString("");
      if (setOpen) {
        setOpen(false);
      }
      // query.delete("brandId");
      // query.set("searchString", searchString);
      // history.push({ search: query.toString() });
    }
  };

  const handleGroupClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const value = e.currentTarget.value;
    if (selectedGroup === value) {
      setSelectedGroup("");
    } else {
      setSelectedGroup(value);
    }
  };

  return (
    <div
      className={classes.container}
      onMouseEnter={() => setOpen && setOpen(true)}
      onMouseLeave={() => setOpen && setOpen(false)}
    >
      <form className={classes.searchBar} onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="SEARCH"
          onChange={handleChange}
          value={searchString}
        />
        <button>
          <SearchIcon height="1rem" />
        </button>
      </form>
      <div className={classes.oneToZ}>
        {classifiedBrands.map((element: BrandType) => (
          <GroupBtn
            key={element.group}
            element={element}
            selectedGroup={selectedGroup}
            handleGroupClick={handleGroupClick}
          />
        ))}
      </div>
      {/* hidden component to calculate height */}
      <div ref={ref} className={classes.hidden}>
        {classifiedBrands.map((element: BrandType) => (
          <Brand
            key={element.group}
            element={element}
            selectedGroup={selectedGroup}
            setOpen={setOpen}
            closeAll={closeAll}
          />
        ))}
      </div>
      <div className={classes.brandsContainer}>
        {classifiedBrands.map((element: BrandType) => (
          <Brand
            key={element.group}
            element={element}
            selectedGroup={selectedGroup}
            setOpen={setOpen}
            closeAll={closeAll}
          />
        ))}
      </div>
      {!setOpen && (
        <button
          onClick={closeDrawer}
          className={`${classes.generalBtn} ${classes.closeBtn}`}
        >
          <CloseIcon width="30" />
        </button>
      )}
    </div>
  );
};

export default ShopByBrandMenu;
